<template>
  <div :class="$mq" class="four-field-frame pb-4 mb-4">

    <br>

    <div class="many-field">
      <div v-if="data.many1" @click="currentField = 1" :class="{ active: currentField === 1 }">{{ this.data.many1 }}</div>
      <div v-if="data.many2" @click="currentField = 2" :class="{ active: currentField === 2 }">{{ this.data.many2 }}</div>
      <div v-if="data.many3" @click="currentField = 3" :class="{ active: currentField === 3 }">{{ this.data.many3 }}</div>
      <div v-if="data.many4" @click="currentField = 4" :class="{ active: currentField === 4 }">{{ this.data.many4 }}</div>
      <div v-if="data.many5" @click="currentField = 5" :class="{ active: currentField === 5 }">{{ this.data.many5 }}</div>
      <div v-if="data.many6" @click="currentField = 6" :class="{ active: currentField === 6 }">{{ this.data.many6 }}</div>
      <div v-if="data.many7" @click="currentField = 7" :class="{ active: currentField === 7 }">{{ this.data.many7 }}</div>
      <div v-if="data.many8" @click="currentField = 8" :class="{ active: currentField === 8 }">{{ this.data.many8 }}</div>
      <div v-if="data.many9" @click="currentField = 9" :class="{ active: currentField === 9 }">{{ this.data.many9 }}</div>
      <div v-if="data.many10" @click="currentField = 10" :class="{ active: currentField === 10 }">{{ this.data.many10 }}</div>
    </div>

    <br>

    <!-- kustomoitu kuvasisältö aiheessa: "Ryhmärakennuttamisen resepti Suomessa" -->
    <div v-if="$route.params.topic_id === 'ryhmarakennuttamisen-resepti-suomessa'" class="ryhmarak-bg">
      <!-- <img src="/images/ryhmarak_1.jpg"> -->
      <img v-if="currentField === 1" src="/images/ryhmarak_1.jpg">
      <img v-else-if="currentField === 2" src="/images/ryhmarak_2.jpg">
      <img v-else-if="currentField === 3" src="/images/ryhmarak_3.jpg">
      <img v-else-if="currentField === 4" src="/images/ryhmarak_4.jpg">
      <img v-else-if="currentField === 5" src="/images/ryhmarak_5.jpg">
    </div>

    <div class="text-content-html">
      <div v-if="currentField === 1" v-html="data.manyMainInfo1"></div>
      <!-- <div v-if="currentField === 1">{{ this.data.manyMainInfo1 }}</div> -->
      <div v-else-if="currentField === 2" v-html="data.manyMainInfo2"></div>
      <div v-else-if="currentField === 3" v-html="data.manyMainInfo3"></div>
      <div v-else-if="currentField === 4" v-html="data.manyMainInfo4"></div>
      <div v-else-if="currentField === 5" v-html="data.manyMainInfo5"></div>
      <div v-else-if="currentField === 6" v-html="data.manyMainInfo6"></div>
      <div v-else-if="currentField === 7" v-html="data.manyMainInfo7"></div>
      <div v-else-if="currentField === 8" v-html="data.manyMainInfo8"></div>
      <div v-else-if="currentField === 9" v-html="data.manyMainInfo9"></div>
      <div v-else-if="currentField === 10" v-html="data.manyMainInfo10"></div>
    </div>

    <!-- monikenttä -->
    <!-- <div class="four-field">
      <div @click="oneOfFour('A')" :class="{ active: currentField === 'A'}" class="four-one">{{ this.data.four1 }}</div>
      <div @click="oneOfFour('B')" :class="{ active: currentField === 'B'}" class="four-two">{{ this.data.four2 }}</div>
      <div @click="oneOfFour('C')" :class="{ active: currentField === 'C'}" class="four-three">{{ this.data.four3 }}</div>
      <div @click="oneOfFour('D')" :class="{ active: currentField === 'D'}" class="four-four">{{ this.data.four4 }}</div>
      <div class="four-top">{{ this.textTop }}</div>
      <div class="four-bottom">{{ this.textBottom }}</div>
      <div class="four-left flex flex-center">
        <span>{{ this.textLeft }}</span>
      </div>
      <div class="four-right flex flex-center">
        <span>{{ this.textRight }}</span>
      </div>
    </div> -->

  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object
    }
  },

  data () {
    return {
      currentField: null
    }
  }

  /* methods: {
    oneOfMany (data) {
      this.currentField = data
      //this.$emit('input', data)
    }
  } */
}
</script>

<style lang="scss">
@import "@/styles/styles.scss";

.many-field {
  & > div {
    margin-bottom: 5px;
    padding: 0 10px;
    border-radius: 3px;
    cursor: pointer;
    &:hover { background-color: rgb(235, 235, 235);}
    &.active { color: rgb(255, 187, 0); }
  }
  font-weight: 700;
  color: rgb(0, 32, 100);
  text-decoration: none;
}
.ryhmarak-bg {
  position: relative;
  margin: 1rem 0 1.5rem 0;
  img {
    display: block;
    margin: 0 auto;
    width: auto;
    max-width: 100%;
    height: auto;
    max-height: 350px;
  }
}
</style>
